import type { MarkStyleConfig } from './types';

export const MARK_STYLE_CONFIG: MarkStyleConfig = {
  baseStyle: {
    bg: 'unset',
    padding: 'unset',
    color: 'brand.secondary',
    boxDecorationBreak: 'clone',
  },
};
